import React from 'react'
import Footer from './components/footer'
import Services from './components/Services'
function ServicesPage(){
	return(
	<>
	<section id="services">
      <div class="container">
        <div class="section-header"><br/><br/><br/><br/><br/><Services /></div></div></section>
		<Footer/>
		</>
)
	}
	
export default ServicesPage